module.exports = __webpack_public_path__ + "media/images/gallery/constellations/rn_layer_on-172added6a03e938c9e1c151b59f5b4b.png";